const TRACK_COLOR_PATHS = ['event', 'template'];

export const isColorDependsPath = (path: string) => {
  return TRACK_COLOR_PATHS.some(option => option === path);
};
